import { useEffect, useRef, useState } from 'react';
import { MerchantUserModel } from '../../../models/merchantUser';
import { MerChantModel } from '../../../models/merChantModel';
import axios from '../../../lib/axios';
import { MERCHANT_STORE_FIND_MANY } from '../../../lib/endpoints/merchants';
import { RoleAndPermissionModel } from '../../../models/roleAndPermission';
import { useTranslation } from 'react-i18next';
// import { GenderEnum } from '../../enums/genderEnum';
import {
  CHANGE_PASSWORD,
  CREATE_MERCHANT_USER,
  FIND_ROLE_AND_PERMISSION,
  IMAGE_URL_MERCHANT_USER,
  UPDATE_MERCHANT_USER,
  UPDATE_MERCHANT_USER_PROFILE,
} from '../../../lib/endpoints/merchantUser';
import { generateImageFileNameWithRandomName } from '../../../utils/generateImageFileName';
import { MerchantUserEnum } from '../../../enums/merchantUser';
import { ProvinceModel } from '../../../models/province';
import provinceData from '../../../data/laos_provinces.json';
import { District } from '../../../models/district';
const dataProvinceFromJson: ProvinceModel[] = provinceData;

interface Props {
  onClose: VoidFunction;
  selectedData: MerchantUserModel;
  onFetchData: Function;
  setSelected: Function;
  branchValue: string;
  merchantType: MerchantUserEnum;
}

export const useFormJiffyStaffController = ({
  onClose,
  selectedData,
  onFetchData,
  setSelected,
  branchValue,
  merchantType,
}: Props) => {
  const [roleAndPermissionData, setRoleAndPermissionData] = useState<RoleAndPermissionModel[]>([]);
  const [roleAndPermissionValue, setRoleAndPermissionValue] = useState<string>(null!);
  // const [selectedGender, setSelectedGender] = useState<GenderEnum>(GenderEnum.OTHER);
  const [provinceValue, setProvinceValue] = useState<string>(null!);
  const [districtsValue, setDistrictsValue] = useState<string>(null!);
  const [districtsData, setDistrictsData] = useState<District[]>([]);

  const [banValue, setBanValue] = useState<boolean>(false);
  const [imageToShow, setImageToShow] = useState<any>(null!);
  const [imageFile, setImageFile] = useState<any>(null!);
  const [errorMessage, setErrorMessage] = useState<string>(null!);
  const [loadingConfirmForm, setLoadingConfirmForm] = useState<boolean>(false);
  const [openConfirm, setOpenConfirm] = useState<boolean>(false);
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState<boolean>(false);

  const firstName = useRef<HTMLInputElement>(null!);
  const lastName = useRef<HTMLInputElement>(null!);
  const tel = useRef<HTMLInputElement>(null!);
  const email = useRef<HTMLInputElement>(null!);
  const village = useRef<HTMLInputElement>(null!);
  const city = useRef<HTMLInputElement>(null!);
  const province = useRef<HTMLInputElement>(null!);
  const userName = useRef<HTMLInputElement>(null!);
  const password = useRef<HTMLInputElement>(null!);
  const confirmPassword = useRef<HTMLInputElement>(null!);

  const { t } = useTranslation('global');

  const handleFetchData = async () => {
    try {
      const roleResponse = await axios.post(FIND_ROLE_AND_PERMISSION);
      if (roleResponse?.data?.length > 0) {
        setRoleAndPermissionData(
          roleResponse.data?.filter(
            (item: any) => item?.role_type === 'STAFF' || item?.role_type === 'MERCHANT'
          )
        );
        setRoleAndPermissionValue(
          roleResponse.data?.filter((item: any) => {
            if (merchantType === MerchantUserEnum.MERCHANT) {
              return item?.role_type === 'MERCHANT';
            } else if (merchantType === MerchantUserEnum.STAFF) {
              return item?.role_type === 'STAFF';
            }
            return false;
          })[0]?.id
        );
      }
    } catch (err) {
      // console.log(err);
    }
  };

  const handleSelectedProvince = (e: any) => {
    setProvinceValue(e.target.value);
  };

  const handleSelectedDistrict = (e: any) => {
    setDistrictsValue(e.target.value);
  };

  const handleShowPassword = () => {
    setShowPassword((prevState) => !prevState);
  };

  const handleShowConfirmPassword = (e: any) => {
    setShowConfirmPassword((prevState) => !prevState);
  };

  const handleBanUser = (newValue: boolean) => {
    setBanValue(newValue);
  };

  const handleChangeRoleAndPermission = (newValue: string) => {
    setRoleAndPermissionValue(newValue);
  };

  const handleSelectedImage = (e: any) => {
    const file = e.target.files[0];
    setImageFile(file);
    const reader = new FileReader();
    reader.onload = () => {
      if (reader.readyState === 2) {
        setImageToShow(reader.result);
      }
    };
    reader.readAsDataURL(file);
    setImageToShow(file);
  };

  const handleRest = () => {
    setSelected(null);
    setImageToShow(null);
    setImageFile(null);
    setRoleAndPermissionValue(null!);

    if (firstName.current) firstName.current.value = '';
    if (lastName.current) lastName.current.value = '';
    if (tel.current) tel.current.value = '';
    if (email.current) email.current.value = '';
    if (village.current) village.current.value = '';
    if (userName.current) userName.current.value = '';
    if (password.current) password.current.value = '';
  };

  const handleValidateForm = () => {
    if (!selectedData && !imageFile) {
      setErrorMessage('Please select an image.');
      return false;
    }
    if (!/^\d+$/.test(tel.current?.value)) {
      setErrorMessage('Phone number must contain only digits and be number.');
      return false;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.current?.value)) {
      setErrorMessage('Please enter a valid email address.');
      return false;
    }
    if (!provinceValue) {
      setErrorMessage('Please select a province.');
      return false;
    }
    if (!districtsValue) {
      setErrorMessage('Please select a districts.');
      return false;
    }
    if (password.current?.value !== confirmPassword.current?.value) {
      setErrorMessage('Password and Confirm Password do not match.');
      return false;
    }
    setErrorMessage('');
    return true;
  };

  const handleOpenConfirmForm = (e: any) => {
    e.preventDefault();
    if (handleValidateForm()) {
      setOpenConfirm(true);
    }
  };

  const handleSubmit = () => {
    if (selectedData?.id) {
      handleEditMerchantUser();
    } else {
      handleCreateMerchantUser();
    }
  };

  const handleCreateMerchantUser = async () => {
    try {
      setLoadingConfirmForm(true);

      const formUser = {
        merchantId: branchValue,
        username: userName.current.value,
        password: password.current.value,
        roleId: roleAndPermissionValue,
      };

      const res = await axios.post(CREATE_MERCHANT_USER, formUser);
      const profileId = res?.data?.profile?.id;

      const formData: any = new FormData();
      formData.append('firstname', firstName.current.value);
      formData.append('lastname', lastName.current.value);
      formData.append('tel', tel.current.value);
      formData.append('email', email.current.value);
      formData.append('village', village.current.value);
      formData.append('province', provinceValue);
      formData.append('city', districtsValue);
      formData.append('file', generateImageFileNameWithRandomName(imageFile));

      await axios.patch(UPDATE_MERCHANT_USER_PROFILE + profileId, formData);
      await onFetchData();
      handleRest();
      onClose();
    } catch (error: any) {
      try {
        const getErrorMessage: string = error.response.data.message;
        setErrorMessage(getErrorMessage);
      } catch (err) {
        setErrorMessage(t('Server error please try again') || '');
      }
    } finally {
      setLoadingConfirmForm(false);
      setOpenConfirm(false);
    }
  };

  const handleEditMerchantUser = async () => {
    try {
      setLoadingConfirmForm(true);
      const inputForm = {
        merchantId: branchValue,
        roleId: roleAndPermissionValue,

        isBan: banValue,
      };
      await axios.patch(UPDATE_MERCHANT_USER + selectedData?.id, inputForm);
      const formData: any = new FormData();
      formData.append('firstname', firstName.current.value);
      formData.append('lastname', lastName.current.value);
      formData.append('tel', tel.current.value);
      formData.append('email', email.current.value);
      formData.append('village', village.current.value);
      formData.append('province', provinceValue);
      formData.append('city', districtsValue);
      if (imageFile) {
        formData.append('file', generateImageFileNameWithRandomName(imageFile));
      }
      await axios.patch(UPDATE_MERCHANT_USER_PROFILE + selectedData?.profile?.id, formData);
      await axios.patch(
        `${CHANGE_PASSWORD}?Id=${selectedData?.id}&password=${password.current.value}`
      );
      await onFetchData();
      handleRest();
      onClose();
    } catch (error: any) {
      try {
        const getErrorMessage: string = error.response.data.message;
        setErrorMessage(getErrorMessage);
      } catch (err) {
        setErrorMessage(t('Server error please try again') || '');
      }
    } finally {
      setLoadingConfirmForm(false);
      setOpenConfirm(false);
    }
  };

  const handleCloseConfirmForm = () => {
    setOpenConfirm(false);
  };

  useEffect(() => {
    if (selectedData) {
      firstName.current.value = selectedData?.profile?.firstname;
      lastName.current.value = selectedData?.profile?.lastname;
      tel.current.value = selectedData?.profile?.tel;
      email.current.value = selectedData?.profile?.email;
      village.current.value = selectedData?.profile?.village;
      setProvinceValue(selectedData.profile?.province);
      setDistrictsValue(selectedData.profile?.city);
      userName.current.value = selectedData?.username;
      setRoleAndPermissionValue(selectedData?.roleId);
      setBanValue(selectedData?.isBan);
      setImageToShow(IMAGE_URL_MERCHANT_USER + selectedData?.profile?.image?.url);
    }
    handleFetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedData]);

  useEffect(() => {
    if (provinceValue) {
      const districtData = dataProvinceFromJson.filter(
        (item) => item?.provinceNameLA === provinceValue
      )[0]?.districts;

      if (districtData?.length > 0) {
        setDistrictsData(districtData);
        setDistrictsValue(districtData[0]?.districtNameLA);
      } else {
        setDistrictsData(districtData);
        setDistrictsValue(null!);
      }
      if (selectedData) {
        setDistrictsValue(selectedData?.profile?.city);
      }
    }
  }, [provinceValue]);

  return {
    handleBanUser,
    banValue,
    handleSelectedImage,
    imageToShow,
    openConfirm,
    handleOpenConfirmForm,
    handleCloseConfirmForm,
    errorMessage,
    handleChangeRoleAndPermission,
    roleAndPermissionValue,
    roleAndPermissionData,
    firstName,
    lastName,
    tel,
    email,
    village,
    province,
    city,
    userName,
    password,
    handleSubmit,
    loadingConfirmForm,
    handleRest,
    handleEditMerchantUser,
    confirmPassword,
    handleShowPassword,
    handleShowConfirmPassword,
    showConfirmPassword,
    showPassword,
    handleSelectedProvince,
    provinceValue,
    provinceData,
    handleSelectedDistrict,
    districtsValue,
    districtsData,
  };
};
